import { Close } from '@material-ui/icons';
import { LabeledText } from '../../../components/LabeledText';
import { IconButton } from '../../../components/IconButton';

interface Props {
  devices: CreateAccountDevice[];
  onRemove(id: string): void;
}

export const DeviceList = ({ devices, onRemove }: Props) => (
  <div className="flex flex-col gap-4 items-start">
    {devices.map((item: CreateAccountDevice) => (
      <div
        key={item.device.id}
        className="flex flex-col w-full border-l-2 border-primary mt-4 px-2"
      >
        <p className="text-primary text-lg">{item.location}</p>
        <div className="flex flex-row flex-wrap grow justify-between">
          <LabeledText
            align="left"
            label="Model"
            text={item.device.modelName}
            labelSize={12}
            textSize={12}
          />
          <LabeledText
            align="left"
            label="MAC Address"
            text={item.device.mac}
            labelSize={12}
            textSize={12}
          />
          <LabeledText
            align="left"
            label="GUID"
            text={item.device.id}
            labelSize={12}
            textSize={12}
          />
          <LabeledText
            align="left"
            label="Serial"
            maxWidth={150}
            noWrap
            text={item.device.serial}
            labelSize={12}
            textSize={12}
          />
          <IconButton onClick={() => onRemove(item.device.id)}>
            <Close />
          </IconButton>
        </div>
      </div>
    ))}
  </div>
);
